<template>
  <div>
    <CRow>
      <CCol sm="12">&nbsp;</CCol>
      <CCol sm="12">
        <GlobalTable
          :title="title + ' List'"
          :fields="fields"
          :items="data"
          :editButton="true"
          :redirectDetail="false"
          :enableAddButton="true"
          :isLoading="isLoading"
          :withCard="false"
          @addForm="addForm"
          @editForm="editForm"
        ></GlobalTable>
      </CCol>
    </CRow>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title" v-if="isEdit == true">Edit Form {{ title }}</h6>
        <h6 class="modal-title" v-if="isEdit == false">Add Form {{ title }}</h6>
      </template>

      <Loading v-if="isLoading"></Loading>
      <CForm v-else>
        <CRow>
          <!-- <CCol sm="6">
            <CTextarea
              label="Messages"
              invalid-feedback="Messages should be filled"
              required
              v-model="$v.contactUsDiscussionForm.messages.$model"
              :is-valid="!$v.contactUsDiscussionForm.messages.$invalid"
              :rows="4"
            ></CTextarea>
          </CCol> -->
          <CCol sm="9">
              <label for="nik">Messages</label>
              <quill-editor style="height: 200px; margin-bottom:70px;"
                :content="content"
                :options="editorOption"
                v-model="$v.contactUsDiscussionForm.messages.$model"
                @change="onEditorChange($event)">
              </quill-editor>
              <div v-if="$v.contactUsDiscussionForm.messages.$invalid" class="invalid-feedback-custom">
                Messages harus di isi.
              </div>
            </CCol>
        </CRow>
      </CForm>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton
          @click="submitForm"
          :disabled="$v.contactUsDiscussionForm.$invalid"
          color="success"
        >
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>

    
  </div>
</template>

<script>
import Loading from "../../../../templates/Loading";
import GlobalTable from "../../../../templates/Table";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'

export default {
  name: "Respond_List",
  components: { GlobalTable, Loading, quillEditor },
  data() {
    return {
      title: "Respond List",
      activeTab: 0,
      fields: [
        { key: "messages", label: "Messages", sorter: true },
        { key: "response_by", label: "Response By", sorter: true },
        { key: "date_inserted", label: "Response Time", sorter: true },
        { key: "action", _classes: "text-center action" },
      ],
      contactUsDiscussionForm: tableInterfaces.contact_us_discussion,
      userForm: tableInterfaces.users,
      addButton: false,
      items: [],
      isEdit: false,
      isLoading: false,
      content: '',editorOption: {},	
      
      
    };
  },
  props: {
    contactUsData: {
      type: [Array, Object],
      default: () => [],
    },

    contactUs: {
      type: [Array, Object],
      default: () => [],
    },
  },
  validations: {
    contactUsDiscussionForm: {
      messages: { required },
      response_by: {},
      response_time: {},
      ticket_number: {},
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },

  computed: {
    data: function () {
      return this.items.length > 0 ? this.items : this.contactUsData;
    },
  },

  methods: {
    init: function () {
      this.isEdit = false;
    },
    refreshComplaintDetail: function (id) {
      this.isLoading = true;
      this.resetForm();
      this.axios
        .get("console/master/contact_us/listing-detail/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.items = response.data.data;
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
          this.cancelForm();
        });
    },
    submitForm: function (event) {
      event.preventDefault();
      this.contactUsDiscussionForm.ticket_number = this.contactUs.ticket_number;
      if (this.isEdit === false) {
        if (confirm("Do you want to add this data ?")) {
          this.isLoading = true;
          this.axios
            .post("console/master/contact_us/add-response", this.contactUsDiscussionForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              
              this.refreshComplaintDetail(this.contactUs.id);
            });
        }
      } else {
        if (confirm("Do you want to update this data ?")) {
          this.isLoading = true;
          this.axios
            .put("console/master/contact_us/update-response", this.contactUsDiscussionForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.refreshComplaintDetail(this.contactUs.id);
            });
        }
      }
    },
    addForm: function () {
      this.addButton = true;
      this.isEdit = false;
      this.resetForm();
      
    },
    editForm: function (item) {
      this.isEdit = true;
      this.contactUsDiscussionForm = item;
      this.addButton = true;
    },
    resetForm: function () {
      for (var i in tableInterfaces.contact_us_discussion) {
        tableInterfaces.contact_us_discussion[i] = null;
      }
      this.contactUsDiscussionForm = tableInterfaces.contact_us_discussion;
    },
    cancelForm: function () {
      this.addButton = false;
      this.preview = false;
      this.resetForm();
    },
    onEditorChange({ quill, html, text }) {
      this.content = html
      this.contactUsDiscussionForm.messages = html
    },
    
    
    
  },
  mounted() {
    this.init();
  },
};
</script>
